import auth from '../services/authService';
import { getSetting, setSetting, settingKeys } from '../utils/settings';

/**
 * Saves welcome modal data to localStorage to persist across page reloads
 * @param {Object} data - Welcome modal data to save
 */
export function saveWelcomeModalData(data) {
  setSetting(settingKeys.welcomeModalData, data);
}

/**
 * Clears welcome modal data from localStorage
 */
export function clearWelcomeModalData() {
  setSetting(settingKeys.welcomeModalData, null);
}

/**
 * Loads welcome modal data from localStorage if it exists
 * @param {Function} setWelcomeModalData - Function to set welcome modal data in context
 * @param {Function} setShowWelcomeModal - Function to show the welcome modal
 */
export function loadWelcomeModalData(setWelcomeModalData, setShowWelcomeModal) {
  const user = auth.getCurrentUser();
  const savedData = getSetting(settingKeys.welcomeModalData);

  if (savedData && user && user.teamId) {
    setWelcomeModalData(savedData);
    setShowWelcomeModal(true);
  }
}
